import React, { Fragment, useRef } from "react";
import _ from "lodash";

import CpapTrialRegisterFields from "./CpapTrialRegisterFields";
import cpapTrialTicketFields from "./cpapTrialTicketFields";

export const CpapTrialTicketForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(
      cpapTrialTicketFields,
      ({
        label,
        name,
        type,
        options,
        required,
        disabled,
        description,
        autoFilled,
      }) => {
        const shouldDisableField =
          autoFilled &&
          props.patientData &&
          props.patientData[name] &&
          props.patientData[name] !== "";

        return (
          <CpapTrialRegisterFields
            name={name}
            label={label}
            type={type}
            value={
              name === "hn"
                ? props.patientData.hn
                : name === "brand"
                ? props.patientData.brand
                : name === "model"
                ? props.patientData.model
                : name === "cpapType"
                ? props.patientData.cpapType
                : name === "serviceOrderNumber"
                ? props.serviceOrderNumber
                : inputRef.current.name
            }
            fileNames={props.fileNames}
            defaultfiles={props.defaultfiles}
            options={options}
            required={required}
            initailValue={
              props.initailValues ? props.initailValues[name] : null
            }
            onChange={props.onChange(name)}
            disabled={disabled || shouldDisableField}
            description={description}
            product={props.product}
            onViewFile={props.onViewFile}
            ticketId={props.ticketId}
            onProductFound={props.onProductFound}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
